// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"a0597c30","17":"bc495026","304":"a5541d5e","488":"ab6abca2","728":"33ec9ce5","785":"01b46386","873":"1978ac3b"}[chunkId] + ".chunk.js";
};